import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
export function FounderStory() {
  return <Section background="sand" data-id="element-74">
      <div className="mb-12" data-id="element-75">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold text-primary-deep-blue mb-4 text-center" data-id="element-76">
          Meet Our Co-Founders
        </h2>
        <p className="text-lg font-inter text-neutral-charcoal text-center max-w-3xl mx-auto mb-12" data-id="element-77">
          Two sisters united by heritage, driven by purpose, building a bridge
          between American resources and Egyptian communities in need.
        </p>
      </div>

      {/* Natasha Khalil */}
      <div className="grid md:grid-cols-5 gap-12 items-center mb-16" data-id="element-78">
        <div className="md:col-span-2" data-id="element-79">
          <div className="rounded-2xl overflow-hidden shadow-lg" data-id="element-80">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nbJVafVZgRcxD2AxVMVQyD/0225681B-F332-4CF8-BE10-DDAFB26CF5D9_1_105_c.jpg" alt="Natasha Khalil, Co-Founder of Farasha Medical Aid" className="w-full h-full object-cover" data-id="element-81" />
          </div>
        </div>
        <div className="md:col-span-3" data-id="element-82">
          <h3 className="text-2xl md:text-3xl font-playfair font-bold text-primary-deep-blue mb-2" data-id="element-83">
            Natasha Khalil
          </h3>
          <p className="text-lg font-inter text-primary-royal-blue mb-4" data-id="element-84">
            Co-Founder & Executive Director
          </p>
          <p className="text-lg font-inter text-neutral-charcoal mb-4" data-id="element-85">
            Natasha Khalil, a first-generation Egyptian-Mexican American,
            founded Farasha Medical Aid after witnessing how healthcare
            disparities affected communities in Egypt, where her father was
            raised.
          </p>
          <p className="text-lg font-inter text-neutral-charcoal mb-6" data-id="element-86">
            With a B.A. in Psychology from Loyola Marymount University and
            preparing for medical school, Natasha leads Farasha's logistics and
            monastery partnerships, combining academic rigor with compassionate
            action.
          </p>
        </div>
      </div>

      {/* Nicole Khalil */}
      <div className="grid md:grid-cols-5 gap-12 items-center" data-id="element-87">
        <div className="md:col-span-3 order-2 md:order-1" data-id="element-88">
          <h3 className="text-2xl md:text-3xl font-playfair font-bold text-primary-deep-blue mb-2" data-id="element-89">
            Nicole Khalil
          </h3>
          <p className="text-lg font-inter text-primary-royal-blue mb-4" data-id="element-90">
            Co-Founder & Communications Director
          </p>
          <p className="text-lg font-inter text-neutral-charcoal mb-4" data-id="element-91">
            Nicole Khalil is a student at Loyola Marymount University pursuing a
            Bachelor of Arts in English and minor in Theological Studies. While
            pursuing her degree, Nicole noticed that the most important stories
            are often suppressed, overshadowed, or entirely forgotten by
            dominant cultural narratives.
          </p>
          <p className="text-lg font-inter text-neutral-charcoal mb-6" data-id="element-92">
            Through her blog posts, she strives to counteract this trend by
            revealing the trials and tribulations of the Coptic people. She
            hopes, in doing so, her posts will incite cultural awareness and
            meaningful action toward the pursuit of change.
          </p>
        </div>
        <div className="md:col-span-2 order-1 md:order-2" data-id="element-93">
          <div className="rounded-2xl overflow-hidden shadow-lg" data-id="element-94">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kaALpsMzDtAjX55veVz28S/3EF4819E-249B-4E37-B8FE-31CEA4263BEE_1_105_c.jpg" alt="Nicole Khalil, Co-Founder of Farasha Medical Aid" className="w-full h-full object-cover" data-id="element-95" />
          </div>
        </div>
      </div>

      <div className="mt-12 text-center" data-id="element-96">
        <p className="text-lg font-inter text-neutral-charcoal mb-6 max-w-3xl mx-auto" data-id="element-97">
          "Farasha"—butterfly in Arabic—honors our late grandmother, Kamilia,
          and symbolizes how small, focused interventions can create meaningful
          transformation in healthcare access for underserved communities.
        </p>
        <Button href="/about" variant="secondary" data-id="element-98">
          Read Our Full Story
        </Button>
      </div>
    </Section>;
}